export default __webpack_public_path__ + "static/media/iulian_curte.3813433f.png";